import React from 'react';
import { MapPin, Navigation } from 'lucide-react';
import { AnimateOnScroll } from './AnimateOnScroll';
const stations = [{
  name: 'Ciruelo Gas',
  location: 'Santiago',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Ciruelo+Gas+Santiago+RD',
  color: '#FCEE02'
}, {
  name: 'Baitoa Gas',
  location: 'Santiago',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Baitoa+Gas+Santiago+RD',
  color: '#EC2424'
}, {
  name: 'La Herradura Gas',
  location: 'Santiago-Sajoma',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=La+Herradura+Gas+Santiago+RD',
  color: '#FB900D'
}, {
  name: 'Verdun Gas',
  location: 'San José De Las Matas',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Verdun+Gas+SAJOMA+RD',
  color: '#FCEE02'
}, {
  name: 'Pedregal Gas',
  location: 'San José De Las Matas',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Pedregal+Gas+SAJOMA+RD',
  color: '#EC2424'
}, {
  name: 'Junquito Gas',
  location: 'Valverde Mao',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Junquito+Gas+Mao+RD',
  color: '#FB900D'
}, {
  name: 'Burende Gas',
  location: 'La Vega',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Burende+Gas+La+Vega+RD',
  color: '#FCEE02'
}, {
  name: 'San José Gas',
  location: 'Santiago',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=San+Jose+Gas+Santiago+RD',
  color: '#EC2424'
}, {
  name: 'Monumental Gas',
  location: 'Santo Domingo',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Monumental+Gas+Santo+Domingo+Distrito+Nacional+RD',
  color: '#FB900D'
}, {
  name: 'NEXT',
  location: 'Santiago - Plaza Jardines Bella Vista',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Plaza+Jardines+Bella+Vista+Av+Antonio+Guzman+Santiago+RD',
  color: '#FCEE02'
}];
export function StationsSection() {
  return <section className="py-16 sm:py-24 relative overflow-hidden transition-colors duration-300" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-332">
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'linear-gradient(#EC2424 1px, transparent 1px), linear-gradient(90deg, #EC2424 1px, transparent 1px)',
      backgroundSize: '60px 60px'
    }} data-id="element-333" />

      <div className="container mx-auto px-4 sm:px-6 md:px-12 relative z-10" data-id="element-334">
        <AnimateOnScroll className="mb-12 sm:mb-16 max-w-3xl" data-id="element-335">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-black uppercase tracking-tighter mb-6 transition-colors duration-300" style={{
          color: 'var(--text-primary)'
        }} data-id="element-336">
            Nuestras{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#EC2424] to-[#FB900D]" data-id="element-337">
              Estaciones
            </span>
          </h2>
          <p className="text-lg sm:text-xl border-l-4 pl-4 sm:pl-6 transition-colors duration-300" style={{
          color: 'var(--text-secondary)',
          borderColor: 'var(--accent-yellow-text)'
        }} data-id="element-338">
            Encuentra la estación más cercana a ti. Estamos estratégicamente
            ubicados para brindarte el mejor servicio.
          </p>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-339">
          {stations.map((station, index) => <AnimateOnScroll key={index} delay={index % 3 * 0.1} direction="up" data-id="element-340">
              <div className="group border hover:border-[#FCEE02] transition-all duration-300 relative overflow-hidden flex flex-col h-full rounded-xl" style={{
            backgroundColor: 'var(--card-bg)',
            borderColor: 'var(--border-color)'
          }} data-id="element-341">
                <div className="absolute top-0 left-0 w-full h-1 transition-transform duration-300 origin-left scale-x-0 group-hover:scale-x-100 rounded-t-xl" style={{
              backgroundColor: station.color
            }} data-id="element-342" />

                <div className="p-5 sm:p-8 flex-1" data-id="element-343">
                  <div className="flex justify-between items-start mb-4 sm:mb-6" data-id="element-344">
                    <div className="p-2.5 sm:p-3 border group-hover:border-white/20 transition-colors rounded-lg" style={{
                  backgroundColor: 'var(--bg-primary)',
                  borderColor: 'var(--border-color)'
                }} data-id="element-345">
                      <MapPin className="w-5 h-5 sm:w-6 sm:h-6" style={{
                    color: station.color
                  }} strokeWidth={2} data-id="element-346" />
                    </div>
                    <span className="text-gray-400 font-black text-3xl sm:text-4xl opacity-20 select-none group-hover:opacity-10 transition-opacity" data-id="element-347">
                      {index + 1 < 10 ? `0${index + 1}` : index + 1}
                    </span>
                  </div>

                  <h3 className="text-xl sm:text-2xl font-bold uppercase mb-2 group-hover:text-[#FCEE02] transition-colors" style={{
                color: 'var(--text-primary)'
              }} data-id="element-348">
                    {station.name}
                  </h3>

                  <div className="flex items-center gap-2 mb-4 sm:mb-6" data-id="element-349">
                    <Navigation className="w-4 h-4 text-gray-400" data-id="element-350" />
                    <span className="text-sm font-medium uppercase tracking-wide transition-colors duration-300" style={{
                  color: 'var(--text-secondary)'
                }} data-id="element-351">
                      {station.location}
                    </span>
                  </div>
                </div>

                <a href={station.mapsUrl} target="_blank" rel="noopener noreferrer" className="p-3 sm:p-4 flex justify-between items-center border-t group-hover:bg-[#FCEE02] transition-colors duration-300 cursor-pointer rounded-b-xl" style={{
              backgroundColor: 'var(--bg-tertiary)',
              borderColor: 'var(--border-color)'
            }} data-id="element-352">
                  <span className="text-xs font-bold uppercase tracking-widest text-gray-500 group-hover:text-[#251F1F]" data-id="element-353">
                    Ver Mapa
                  </span>
                  <Navigation className="w-4 h-4 text-gray-500 group-hover:text-[#251F1F]" data-id="element-354" />
                </a>
              </div>
            </AnimateOnScroll>)}
        </div>
      </div>
    </section>;
}